import React from 'react';
// Components
import ManageStoreBio from 'components/common/ManageStoreBio';

const ManageContentCreatorBio = (): JSX.Element => {
  return <ManageStoreBio />;
};

export default ManageContentCreatorBio;
